import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { LoadOptions } from 'devextreme/data/load_options';
import { DxToolbarPreparingEvent } from '../../../../core/dx.types';
import {
  gqlMongoByKey,
  gqlMongoCount,
  gqlMongoLoad,
} from '../../../../shared/classes/loopback-custom-store/generic/store.utils';
import { CommonService } from '../../../../shared/modules/my-common/services/common.service';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { StateStoreService } from '../../../../shared/modules/my-common/services/state-store.service';
import { ABaseComponent } from '../../../../shared/modules/ui/components/abstract/a-base.component';
import { GridHelperService } from '../../../../shared/modules/ui/services/grid-helper.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService } from '../../../../shared/sdk';
import moment from 'moment';

@Component({
  selector: 'app-key-performance-indicators',
  templateUrl: './key-performance-indicators.component.html',
  styleUrls: ['./key-performance-indicators.component.scss'],
})
export class KeyPerformanceIndicatorsComponent extends ABaseComponent implements OnInit, AfterViewInit {
  // isSU$: Observable<boolean>;

  @ViewChild(DxDataGridComponent, { static: true }) grid: DxDataGridComponent;
  grid_stateStoring: any;

  dso: DataSourceOptions;

  periods: any = [
    { name: 'Last 7 Days', value: [7, 'days'] },
    { name: 'Last Month', value: [1, 'month'] },
    { name: 'Last 3 Months', value: [3, 'months'] },
    { name: 'Last 6 Months', value: [6, 'months'] },
    { name: 'Last Year', value: [1, 'year'] },
    { name: 'All Data', value: [] },
  ];
  period: any = this.periods[3].value;

  groups: any = [
    { name: 'Daily', value: 0 },
    { name: 'Weekly', value: 1 },
    { name: 'Monthly', value: 2 },
  ];
  group: any = this.groups[0].value;

  constructor(
    public logger: LoggerService,
    public config: ConfigService,
    public common: CommonService,
    private ui: UiService,
    private sss: StateStoreService,
    private dss: DataSourceService,
    private gridHelper: GridHelperService,
  ) {
    super(logger);

    this.grid_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: '7276d037-36fa-5e37-ab23-32176ee1b3b9',
    };
  }

  ngOnInit() {
    super.ngOnInit();
    this.rebuild();
  }

  rebuild() {
    this.dso = this.buildDataSource();
  }

  grid_onInitialized(e) {}

  grid_onToolbarPreparing(e: DxToolbarPreparingEvent) {
    e.toolbarOptions.items.push({
      ...{ name: 'refresh', locateInMenu: 'auto', location: 'after', widget: 'dxButton', showText: 'inMenu' },
      options: { icon: 'refresh', text: 'Refresh', hint: 'Refresh', onClick: () => e.component.refresh() },
    });
  }

  ngAfterViewInit(): void {}

  getCellClass(val, range) {
    if (!val) return '';
    // const days = [1, 5, 22];
    // const range = [days[this.group] * dayRange[0], days[this.group] * dayRange[1]];
    if (val < range[0]) return 'red';
    if (val < range[1]) return 'orange';
    return 'green';
  }

  private buildDataSource() {
    const self = this;
    const col = 'EmployeeOnDuty';
    const dateString = {
      $concat: [{ $substr: ['$_id', 0, 4] }, '-', { $substr: ['$_id', 4, 2] }, '-', { $substr: ['$_id', 6, 2] }],
    };
    const dayly = dateString;
    const $week = { $dateFromString: { dateString: dateString } };
    const groupWeekly = {
      $concat: [
        { $substr: ['$_id', 0, 4] },
        '-W',
        {
          $cond: {
            if: { $lt: [{ $week }, 10] },
            then: { $concat: ['0', { $toString: { $week } }] },
            else: { $toString: { $week } },
          },
        },
      ],
    };
    const monthly = { $concat: [{ $substr: ['$_id', 0, 4] }, '-', { $substr: ['$_id', 4, 2] }] };
    const today = [new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()];
    const [year, month, day] = today;

    const _perSize2 = (num, count) => ({
      $cond: { if: { $eq: [count, 0] }, then: 0, else: { $round: [{ $divide: [num, count] }, 2] } },
    });
    const _dFromParts = (year, month, day) => ({ $dateFromParts: { year, month, day } });

    const lastDayOfMonth = {
      $dayOfMonth: {
        $min: [
          { $subtract: [_dFromParts('$$year', { $add: ['$$month', 1] }, 1), 1 * 24 * 60 * 60 * 1000] }, // first day of the next month minus 1 day
          _dFromParts(year, month, day - 1), // yesterday
        ],
      },
    };

    const addFieldsStage = {
      $addFields: {
        weekDayCount: {
          $switch: {
            branches: [
              {
                case: { $eq: [{ $type: '$_id' }, 'string'] }, // Ensure _id is a string (e.g., "2025-05")
                then: {
                  $let: {
                    vars: {
                      year: { $toInt: { $substr: ['$_id', 0, 4] } }, // Extract year from _id
                      month: { $toInt: { $substr: ['$_id', 5, 2] } }, // Extract month from _id
                    },
                    in: {
                      $size: {
                        $filter: {
                          input: { $range: [1, { $add: [1, lastDayOfMonth] }] }, // Generate range of days in the month
                          as: 'day',
                          cond: {
                            $and: [
                              { $gte: [{ $dayOfWeek: _dFromParts('$$year', '$$month', '$$day') }, 2] }, // Monday
                              { $lte: [{ $dayOfWeek: _dFromParts('$$year', '$$month', '$$day') }, 6] }, // Friday
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
            ],
            default: 21, // Default to 21 weekdays if _id is not a string
          },
        },
      },
    };

    const matchStage = this.period[0]
      ? [{ $match: { day: { $gte: +moment().subtract(this.period[0], this.period[1]).format('YYYYMMDD') } } }]
      : [];

    const calculatedFields = {
      actualTripsCount: 1,
      tripsOnManifestCount: 1,
      canceledTripsCount: 1,
      loadDuration: 1,
      freeTimeDuration: 1,
      onDutyEngineOnDuration: 1,
      onDutyEngineOffDuration: 1,
      onDutyIdleDuration: 1,
      distance: 1,
    };

    const groupDayStages = [
      {
        $group: {
          _id: '$day',
          vehicles: { $addToSet: '$vehicles' },
          employeeIds: { $addToSet: { $cond: { if: { $ne: ['$employeeId', 0] }, then: '$employeeId', else: null } } },
          escortIds: { $addToSet: '$escortIds' },
          clients: { $addToSet: '$consumers' },
          actualTripsCount: { $sum: '$signaturesCount' },
          tripsOnManifestCount: { $sum: '$tripsOnManifestCount' },
          canceledTripsCount: { $sum: '$canceledTripsCount' },
          loadDuration: {
            $sum: { $toInt: { $divide: [{ $subtract: ['$onDutyDuration', '$freeTimeDuration'] }, 3600] } },
          },
          freeTimeDuration: { $sum: { $toInt: { $divide: ['$freeTimeDuration', 3600] } } },
          onDutyEngineOnDuration: { $sum: { $toInt: { $divide: ['$onDutyEngineOnDuration', 3600] } } },
          onDutyEngineOffDuration: { $sum: { $toInt: { $divide: ['$onDutyEngineOffDuration', 3600] } } },
          onDutyIdleDuration: { $sum: { $toInt: { $divide: ['$onDutyIdleDuration', 3600] } } },
          distance: { $sum: { $toInt: '$distance' } },
        },
      },
      {
        $project: {
          _id: 1,
          unqVehicleIds: {
            $reduce: { input: '$vehicles', initialValue: [], in: { $setUnion: ['$$value', '$$this.internalId'] } },
          },
          unqEmployeeIds: {
            $reduce: { input: '$escortIds', initialValue: '$employeeIds', in: { $setUnion: ['$$value', '$$this'] } },
          },
          unqClientIds: {
            $reduce: { input: '$clients', initialValue: [], in: { $setUnion: ['$$value', '$$this.id'] } },
          },
          unqSubscribedClientIds: {
            $reduce: {
              input: '$clients',
              initialValue: [],
              in: {
                $setUnion: [
                  '$$value',
                  {
                    $map: {
                      input: { $filter: { input: '$$this', as: 'this', cond: '$$this.subscribed' } },
                      as: 'filteredClient',
                      in: '$$filteredClient.id',
                    },
                  },
                ],
              },
            },
          },
          ...calculatedFields,
        },
      },
    ];

    const groupStage = {
      $group: {
        _id: [dayly, groupWeekly, monthly][this.group],
        days: { $addToSet: '$_id' },
        vehiclesCount: { $sum: { $size: { $ifNull: ['$unqVehicleIds', []] } } },
        // vehiclesCount: { $sum: 1 },
        // vehiclesCount: { $sum: { $cond: [{ $ifNull: ['$vehicle', false] }, 1, 0] } },
        unqVehicleIds: { $addToSet: '$unqVehicleIds' },
        unqEmployeeIds: { $addToSet: '$unqEmployeeIds' },
        unqClientIds: { $addToSet: '$unqClientIds' },
        unqSubscribedClientIds: { $addToSet: '$unqSubscribedClientIds' },
        actualTripsCount: { $sum: '$actualTripsCount' },
        tripsOnManifestCount: { $sum: '$tripsOnManifestCount' },
        canceledTripsCount: { $sum: '$canceledTripsCount' },
        loadDuration: { $sum: '$loadDuration' },
        freeTimeDuration: { $sum: '$freeTimeDuration' },
        onDutyEngineOnDuration: { $sum: '$onDutyEngineOnDuration' },
        onDutyEngineOffDuration: { $sum: '$onDutyEngineOffDuration' },
        onDutyIdleDuration: { $sum: '$onDutyIdleDuration' },
        distance: { $sum: '$distance' },
      },
    };

    const projectStages = [
      {
        $project: {
          _id: 1,
          daysCount: { $size: '$days' },
          weekDayCount: { $ifNull: ['$weekDayCount', 0] },
          vehiclesCount: 1,
          unqVehiclesCount: {
            $size: {
              $reduce: { input: '$unqVehicleIds', initialValue: [], in: { $setUnion: ['$$value', '$$this'] } },
            },
          },
          unqEmployeesCount: {
            $size: {
              $reduce: { input: '$unqEmployeeIds', initialValue: [], in: { $setUnion: ['$$value', '$$this'] } },
            },
          },
          unqClientsCount: {
            $size: {
              $reduce: { input: '$unqClientIds', initialValue: [], in: { $setUnion: ['$$value', '$$this'] } },
            },
          },
          unqSubscribedClientsCount: {
            $size: {
              $reduce: {
                input: '$unqSubscribedClientIds',
                initialValue: [],
                in: { $setUnion: ['$$value', '$$this'] },
              },
            },
          },
          ...calculatedFields,
        },
      },
      {
        $project: {
          _id: 1,
          daysCount: 1,
          vehiclesCount: 1,
          weekDayCount: 1,
          avgVehiclesPerDay: _perSize2('$vehiclesCount', '$daysCount'),
          avgWeekDayVehiclesPerDay: _perSize2('$vehiclesCount', [1, 5, '$weekDayCount'][this.group]),
          unqVehiclesCount: 1,
          unqEmployeesCount: 1,
          unqClientsCount: 1,
          unqSubscribedClientsCount: 1,
          actualTripsCountPerVehicle: _perSize2('$actualTripsCount', '$vehiclesCount'),
          tripsOnManifestCountPerVehicle: _perSize2('$tripsOnManifestCount', '$vehiclesCount'),
          loadDurationPerVehicle: _perSize2('$loadDuration', '$vehiclesCount'),
          freeTimeDurationPerVehicle: _perSize2('$freeTimeDuration', '$vehiclesCount'),
          onDutyEngineOnDurationPerVehicle: _perSize2('$onDutyEngineOnDuration', '$vehiclesCount'),
          onDutyEngineOffDurationPerVehicle: _perSize2('$onDutyEngineOffDuration', '$vehiclesCount'),
          onDutyIdleDurationPerVehicle: _perSize2('$onDutyIdleDuration', '$vehiclesCount'),
          distancePerVehicle: _perSize2('$distance', '$vehiclesCount'),
          ...calculatedFields,
        },
      },
    ];

    const aggregate = [
      ...matchStage,
      ...groupDayStages,
      groupStage,
      ...(this.group === this.groups[2].value ? [addFieldsStage] : []),
      ...projectStages,
    ];

    const store = new CustomStore({
      useDefaultSearch: true,
      cacheRawData: false,
      load: async (loadOptions: LoadOptions): Promise<any> => {
        return gqlMongoLoad(self.dss, col, loadOptions, aggregate).toPromise();
      },
      byKey: async (key: any | string | number): Promise<any> => {
        return gqlMongoByKey(self.dss, col, key).toPromise();
      },
      totalCount: async (loadOptions: LoadOptions): Promise<number> => {
        return gqlMongoCount(self.dss, col, loadOptions, aggregate).toPromise();
      },
    });

    return { store } as DataSourceOptions;
  }

  calculateYesFilterExpression = function (val, op, target) {
    return [this.dataField, ((op === '<>' || op === 'notcontains') && '<>') || '=', 'yes'.includes(val.toLowerCase())];
  };
}
